<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop (contratoenvio)="recibirContrato($event)"></app-menudesktop>
  </div>
  <div class="col-xs-12 col-md-8">
    <!-- <div class="alert alert-info alert-dismissible" ng-cloak *ngIf="showENS" id="alertENS">      
      <p style="text-align: justify;"><strong>Aviso!</strong> En cumplimiento de la normativa de seguridad de la entidad, le recordamos que debe aplicar la normativa de seguridad vigente, y en particular, hacer un uso adecuado de la información, proteger su confidencialidad, prevenir accesos no autorizados, custodiar de manera diligente sus credenciales e informar de manera inmediata a SACYR en caso su pérdida.</p>
    </div> -->
    <alertbox
      style="text-align: justify;"
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <div
      class="row"
      *ngIf="contratoSelected !== undefined && !contratoSelected.Ficticio"
    >
      <!-- <div class="input-form input-text">-->
      <label><b>Dirección suministro</b> {{direccionSuministro}}</label>
      <!--</div>-->
    </div>
    <div class="row scyr-no-avisos">
      <section class="col-xs-12 col-sm-6 col-md-6 scyr-section">
        <div
          *ngIf="existenFacturas"
          class="scyr-ultima-factura box"
        >
          <h2>Su última factura</h2>
          <div class="scyr-ultima-factura-items">
            <div class="scyr-dato total">
              <p class="scyr-dato__xl">{{total | currency: 'EUR'}}</p>
              <p class="">Total a pagar</p>
            </div>
            <div
              *ngIf="fechalectura!=null"
              class="scyr-dato consumo"
            >
              <p class="scyr-dato__xl">{{consumo}}<span>m<sup>3</sup></span></p>
              <p>Consumo</p>
            </div>
            <div
              *ngIf="fechalectura==null"
              class="scyr-dato consumo"
            >
              <p
                class="scyr-dato__xl"
                *ngIf="cobrada"
              >Pagado</p>
              <p
                class="scyr-dato__xl"
                *ngIf="!cobrada"
              >Pendiente</p>
              <p>Estado</p>
            </div>
            <div class="scyr-dato periodo">
              <p class="scyr-dato__sm">Periodo</p>
              <p class="fecha">{{periodo}}</p>
            </div>
            <div
              *ngIf="fechalectura!=null"
              class="scyr-dato fecha"
            >
              <p class="scyr-dato__sm">Fecha lectura</p>
              <p class="fecha">{{fechalectura | date:'dd-MM-yyyy'}}</p>
            </div>
            <div
              *ngIf="fechalectura==null"
              class="scyr-dato fecha"
            >
              <p class="scyr-dato__sm">Fecha factura</p>
              <p class="fecha">{{fechaFactura | date:'dd-MM-yyyy'}}</p>
            </div>
            <span class="white-block"></span>
          </div>
          <div *ngIf="existenFacturas">
            <div
              *ngIf="efactura"
              class="scyr-ultima-factura-btn"
            >
              <button
                type="button"
                (click)="DescargarFactura()"
                class="btn-default"
              >Descargar Factura</button>
            </div>
            <div
              *ngIf="!efactura"
              class="scyr-ultima-factura-btn"
            >
              <button
                type="button"
                (click)="_showModalFactura = true"
                class="btn-default"
              >Descargar Factura</button>
            </div>
            <div
              *ngIf="numeroExpCorteEmmasa !== 0 && permitirPagoOVE && !procesoBajaOficio"
              class="scyr-ultima-factura-btn"
            >
              <button
                type="button"
                (click)="_showModalPasarela = true"
                class="btn-default"
              >Pagar deuda</button>
            </div>
            <a [routerLink]="['/home/consumofactura']">Ver todas mis facturas</a>
          </div>
        </div>
      </section>
      <section class="col-xs-12 col-sm-6 col-md-6 scyr-section">
        <div
          *ngIf="existenFacturas"
          class="scyr-grafico"
        >
          <div class="title-area">
            <h2>Evolución de su consumo</h2>
          </div>
          <div
            id="chart_div"
            class="chart"
          >
            <bar-chart-demo [grafica]="facturas"></bar-chart-demo>
          </div>
        </div>
      </section>
    </div>
    <div class="row">
      <section class="col-xs-12">
        <div class="scyr-accesos">
          <div class="row">
            <div
              *ngIf="!esFicticio"
              class="col-xs-12 col-sm-4 col-md-4 onlyMobileLandscape"
            >
              <div class="scyr-acceso lectura box">
                <h3>Envíe la lectura de su contador</h3>
                <a
                  [routerLink]="['/home/lecturacontador']"
                  href=""
                  class="btn-default"
                >Enviar lectura</a>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4 untilMobileLandscape">
              <div class="scyr-acceso averia box">
                <h3>¿Has visto una avería?</h3>
                <div class="averia-texto">
                  <div class="averia-texto__desktop">
                    <img
                      src="assets/images/icons/llamanos.svg"
                      alt=""
                    >
                    <p>Llámenos al <span>{{telefonoexplotacion}}</span></p>
                  </div>
                  <a
                    href="tel:{{telefonoexplotacion}}"
                    class="btn-default averia-texto__mobile"
                  >{{telefonoexplotacion}}</a>
                </div>
                <a
                  [routerLink]="['/home/averias']"
                  href="#"
                  class="btn-default"
                >NOTIFICAR avería</a>
                <!--[queryParams]="{asunto: 'Avería'}"-->
              </div>
            </div>
            <div
              *ngIf="!esPagadorOInactivo && !esFicticio"
              class="col-xs-12 col-sm-4 col-md-4"
            >
              <div class="scyr-acceso factura box">
                <h3>¿Quiere conocer su facturación?</h3>
                <a
                  [routerLink]="['/home/simuladorConsumo']"
                  class="btn-default"
                  href="#"
                >Calcular ahora</a>
              </div>
            </div>
            <div
              *ngIf="!esFicticio"
              class="col-xs-12 col-sm-4 col-md-4 untilMobileLandscape"
            >
              <div class="scyr-acceso lectura box">
                <h3>Envíe la lectura de su contador</h3>
                <a
                  [routerLink]="['/home/lecturacontador']"
                  class="btn-default"
                  href="#"
                >Enviar lectura</a>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4 onlyMobileLandscape">
              <div class="scyr-acceso averia box">
                <h3>¿Has visto una avería?</h3>
                <div class="averia-texto">
                  <div class="averia-texto__desktop">
                    <img
                      src="assets/images/icons/llamanos.svg"
                      alt=""
                    >
                    <p>Llámenos al <span>{{telefonoexplotacion}}</span></p>
                  </div>
                  <a
                    href="tel:{{telefonoexplotacion}}"
                    class="btn-default averia-texto__mobile"
                  >{{telefonoexplotacion}}</a>
                </div>
                <a
                  [routerLink]="['/home/averia']"
                  href=""
                  class="btn-default"
                >NOTIFICAR avería</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<!-- MODAL -->
<sacyr-modal
  [setTemplateRef]="modal_content"
  [showModal]="showModal()"
  (closeModal)="closeModal()"
></sacyr-modal>

<ng-template #modal_content>

  <ng-container *ngIf="_showModalFactura">
    <div id="modal_factura">
      <h2>¿Aún no recibe la factura electrónica?</h2>
      <div class="modal-factura__texto">
        <div class="modal-img col-xs-6">
          <img
            class="big"
            src="assets/images/icons/icono-modal.svg"
            alt=""
          >
        </div>
        <ul class="col-xs-6">
          <li>SIN PAPEL</li>
          <li>No se pierde</li>
          <li>Siempre disponible</li>
          <li>¡Una ayuda adicional si tienes inquilinos!</li>
        </ul>
      </div>
      <div class="modal-factura__button">
        <a (click)="DescargarFactura()">Descargar Factura</a>
        <button
          (click)="subscribirFacturaElectronica()"
          type="button"
          class="btn-default"
          data-dismiss="modal"
        >subscríbase</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="_showModalPasarela">
    <div id="modal_pasarela">
      <h3>Deuda expediente {{numeroExpCorteEmmasa}}</h3>
      <div class="modal-factura__texto">
        <ul class="col-xs-12">
          <li>-----------</li>
          <li *ngFor="let linea of  expedienteCorteEmmasa.ListaFacturasOrEfecPend"><b>Periodo:</b>
            {{linea.PeriodoFactura === null ? linea.EfectoPendientePeriodo : linea.PeriodoFactura}} <b>Importe
              Pendiente</b>
            {{(linea.FacturaTotalFacturado === 0? linea.EfectoImporteFacturado : linea.FacturaTotalFacturado) -
            (linea.FacturaTotalFacturado === 0 ? linea.EfectoImporteCobrado : linea.FacturaTotalCobrado ) |
            currency: 'EUR'}} </li>
          <li>-----------</li>
          <li><b>Otros cargos</b> {{cargoReconexion | currency: 'EUR' }}</li>
          <li><b>Otros trabajos</b> {{cargosAsocReconexion | currency: 'EUR'}}</li>
          <li>-----------</li>
          <li><b>TOTAL DEUDA EXPEDIENTE</b> {{totalDeudaExpedienteCorteEmmasa | currency: 'EUR'}} </li>
        </ul>
      </div>
      <div class="modal-factura__button">
        <a
          href="{{this.TPVpage}}?explotacion={{this.explotacion}}&importe={{totalDeudaExpedienteCorteEmmasa * 100}}&facCtr={{contrato_num}}&expCorte={{numeroExpCorteEmmasa}}">Clic
          para continuar con el pago</a>
      </div>
    </div>
  </ng-container>
</ng-template>
